<template>

    <div>
        <google-map name="example" :listMarqueur= listMarqueur ></google-map>
    </div>
    <!-- FIN CARTE GOOGLE -->
</template>

<script>
    import GoogleMap from "@/components/map/GoogleMap";
    import Loading from '@/components/Loading';
    export default {
        components:{GoogleMap,Loading},
        name: "ProjetMap",
        props: ["show","listMarqueur"],
        data(){
            return {
                dialogMap: false,
                loading: false,
            }
        },
        methods:{
            closeDialog(){
                this.$emit('close')
            },
        },

        watch: {
            show : function(newValue, oldvalue){
                this.dialogMap = newValue
            }
        },
        mounted(){
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/map/ProjetMap.vue